import fetch from "auth/FetchInterceptor";
import { getToken, http } from "./HttpService";
import { PARTNER_API_BASE, PORTAL_API_BASE, CP_UAM_SUBSCRIPTION_KEY } from "../configs/AppConfig";
import HTTPMethod from "http-method-enum";

const AuthService = {};

AuthService.login = async (params) => {
  return await getToken(params);
};

AuthService.integrationLogin = async (params) => {
  const { username, password, operator, partnerId } = params;
  return await http({
    url: `${PORTAL_API_BASE}/login`,
    header: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": CP_UAM_SUBSCRIPTION_KEY,
    },
    method: HTTPMethod.POST,
    body: {
      username,
      password,
      operator,
      partnerId,
    },
  });
};

AuthService.register = function (data) {
  return fetch({
    url: "/auth/register",
    method: "post",
    data: data,
  });
};

AuthService.logout = async (params) => {
  const { token } = params;
  return await http({
    url: `${PARTNER_API_BASE}/logout`,
    method: "post",
    header: {
      Authorization: `Bearer ${token}`,
    },
  });
};

AuthService.loginInOAuth = function () {
  return fetch({
    url: "/auth/loginInOAuth",
    method: "post",
  });
};

export default AuthService;
